import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from "@xyflow/react";

export function OnCheckoutSuccessEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, id } = props;
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={{ stroke: "#94a3b8", strokeWidth: 2 }} />
      <EdgeLabelRenderer>
        <div
          className="absolute nodrag nopan pointer-events-none rounded-md border border-slate-200 bg-white px-2 py-0.5 text-[10px] font-semibold text-slate-600"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          }}
        >
          On checkout success
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
